import { useCallback, useState } from "react";
import { submitCheckin } from "../../api/checkins/checkinsApi";

const DUPLICATE_CHECKIN_ERROR = "Check-in already exists for this date and type";

function isDuplicateCheckinError(err) {
  const serverError = err?.response?.data?.error;
  return typeof serverError === "string" && serverError.trim() === DUPLICATE_CHECKIN_ERROR;
}

export default function useSubmitCheckin() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submit = useCallback(async (payload) => {
    setIsSubmitting(true);
    setError(null);

    try {
      return await submitCheckin(payload);
    } catch (err) {
      if (isDuplicateCheckinError(err)) {
        // Backend prevents duplicates; treat this as a logical success so UI can proceed to guidance.
        return { duplicate: true };
      }
      const message =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to submit check-in";
      setError(message);
      throw err;
    } finally {
      setIsSubmitting(false);
    }
  }, []);

  return { submit, isSubmitting, error };
}
